import React from "react";
import _ from "lodash";
import { useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { rootReducersState } from "../../../reducers";
import { useSocket } from "../../../components/common/SocketIo";
import { FlashMessage } from "../../../components/common";
// import { feedPostSuccess } from "../../../reducers/feeds/feedPost.reducer";

const SocketPost = () => {
  const sessionReducer = useSelector(
    ({ session }: rootReducersState) => session
  );
  // const dispatch = useDispatch();
  const socket = useSocket();
  const userId = _.get(sessionReducer, "currentUser.id", 0);
  const [displayProgress, setDisplayProgress] = useState(0);
  // const [socketMessage, setSocketMessage] = useState("");
  const [actualProgress, setActualProgress] = useState(0);
  const listenerAttachedRef = useRef(false);
  const lastProgressRef = useRef(0);

  // Inside your component:
  useEffect(() => {
    // On mount, restore last progress from storage (if you want)...
    const storedProgress = localStorage.getItem("postUploadProgress");
    if (storedProgress) {
      const progressValue = parseInt(storedProgress, 10);
      setDisplayProgress(progressValue);
      lastProgressRef.current = progressValue;
      // Optionally clear storage so we don't merge duplicates:
      // localStorage.removeItem("videoUploadProgress");
    }
  }, []);

  useEffect(() => {
    // Update storage every time actualProgress changes
    localStorage.setItem("postUploadProgress", actualProgress.toString());
  }, [actualProgress]);

  useEffect(() => {
    if (!socket.connected) {
      socket.on("connect", () => {
        console.log("✅ Connected to Socket.IO server");
        const postRoom = `${userId}_web_post_room`;
        socket.emit("postRoom", postRoom);
      });
    }

    if (!listenerAttachedRef.current) {
      socket.on("postUploadProgress", (data) => {
        // console.log("Received progress event:", data);
        // Only update if new progress is higher than the last known

        if (data.status === "failed") {
          // show the backend error
          lastProgressRef.current = 0;
          setActualProgress(0);
          setDisplayProgress(0);
          FlashMessage(data.message || "Upload failed", "error");
          // clear any saved progress
          localStorage.removeItem("postUploadProgress");
          // reload after 5s
          setTimeout(() => window.location.reload(), 3000);
          return;
        }
        if (data.progress > lastProgressRef.current) {
          lastProgressRef.current = data.progress;
          setActualProgress(data.progress);
        }
        if (data.progress === 100) {
          // dispatch(
          //   feedPostSuccess({
          //     message: "Post upload Successfully",
          //     data: data,
          //   })
          // );
          // setSocketMessage("Upload successful!");
          // Clear storage upon completion
          localStorage.removeItem("postUploadProgress");
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        }
      });
      listenerAttachedRef.current = true;
    }
    return () => {
      socket.off("postUploadProgress");
      listenerAttachedRef.current = false;
    };
    // eslint-disable-next-line
  }, [userId,socket]);

  useEffect(() => {
    if (actualProgress === 100) {
      setDisplayProgress(100);
      localStorage.removeItem("postUploadProgress");
      return;
    }

    if (displayProgress < actualProgress) {
      const timer = setInterval(() => {
        setDisplayProgress((prev) => {
          if (prev < actualProgress) {
            return prev + 1;
          }
          clearInterval(timer);
          return prev;
        });
      }, 30);
      return () => clearInterval(timer);
    }
  }, [actualProgress, displayProgress]);

  return (
    <div className="post-socket-container">
      {(displayProgress > 0 || actualProgress > 0) && (
        <div className="progress-container">
          <div className="progress-header">
            <span className="progress-label">{displayProgress===100?'':'Post Uploading....'}</span>
            <span className="progress-percent">
              {displayProgress === 100
                ? "Post uploaded successfully!"
                : displayProgress + "%"}
            </span>
          </div>
          <div className="progress-bar-wrapper">
            <div
              className={`progress-bar ${
                displayProgress === 100 ? "complete" : "incomplete"
              }`}
              style={{ width: `${displayProgress}%` }}
            ></div>
          </div>
          {/* {socketMessage && (
            <p
              className={`socket-message ${
                displayProgress === 100 ? "complete" : "incomplete"
              }`}
            >
              {socketMessage}
            </p>
          )} */}
        </div>
      )}
    </div>
  );
};

export default SocketPost;
